import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FCWithChildren } from '../../../../App.types';

const AuthWrapper: FCWithChildren = ({ children }: { children?: ReactNode }) => {
    const authContext = useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    let nextUrl = useMemo(() => {
        const url = encodeURIComponent(pathname + search);
        return !url.includes('/sign-in/') ? `?next=${url}` : '';
    }, [pathname, search]);

    useEffect(() => {
        if (authContext.loading) {
            return;
        } else if (
            !authContext.authenticated &&
            !pathname.includes('/confirm-password/') &&
            !pathname.includes('/forgot-password/') &&
            !pathname.includes('/sign-in/')
        ) {
            navigate(`/sign-in/${nextUrl}`);
        } else {
            setIsAuthenticated(true);
        }
    }, [authContext, navigate, nextUrl, pathname]);

    return isAuthenticated ? <>{children}</> : null;
};

export default AuthWrapper;
